interface NotesInputProps {
  label: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  optional?: boolean;
}

export function NotesInput({ label, placeholder, value, onChange, optional = true }: NotesInputProps) {
  return (
    <div style={{ marginTop: 16 }}>
      <label style={{ display: 'block' }}>
        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-secondary)' }}>{label}</span>
        {optional && <span style={{ fontSize: 11, color: 'var(--text-muted)', marginLeft: 8 }}>Optional</span>}
        <textarea
          value={value}
          onChange={e => onChange(e.target.value)}
          rows={3}
          placeholder={placeholder}
          style={{
            display: 'block', width: '100%', padding: 12, marginTop: 6,
            borderRadius: 8, border: '1px solid var(--color-border)', fontSize: 13,
            fontFamily: 'inherit', resize: 'vertical', boxSizing: 'border-box',
            outline: 'none', background: '#fafafa',
          }}
        />
      </label>
    </div>
  );
}
